// extracted by mini-css-extract-plugin
module.exports = {"containerIntegrations":"styles_containerIntegrations__22uAm","whiteBox":"styles_whiteBox__21scP"};